import { memo } from 'react'
import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { Footer } from './Footer'
import styles from './MainLayout.module.css'

export const MainLayout = memo(() => {
  return (
    <div className={styles.layout}>
      <Header />

      <div className={styles.content}>
        <Sidebar />

        <main className={styles.main}>
          <div className={styles.mainContainer}>
            <Outlet />
          </div>
        </main>
      </div>

      <Footer />
    </div>
  )
})

MainLayout.displayName = 'MainLayout'
